<ng-container *mobxAutorun>
  <ng-container *ngIf="relativeStorage.has() && relativeStorage.get() !== null">
    <!-- Root entry (only show children) -->
    <ng-container *ngIf="displayAsRoot">
      <!-- Children -->
      <ng-container [ngTemplateOutlet]="childrenTemplate"></ng-container>

      <!-- Action at the bottom (with label) -->
      <ng-container
        [ngTemplateOutlet]="actionsTemplate"
        [ngTemplateOutletContext]="{
          addOptionalValueButtonText: addOptionalValueButtonText,
          addValueToListButtonText: addValueToListButtonText
        }"
      ></ng-container>
    </ng-container>

    <!-- Non-root entry (show entry + children) -->
    <div
      *ngIf="!displayAsRoot"
      [ngClass]="{ 'nav-item': true, active: isActive }"
      [class.is-warning]="relativeStorage.shouldShowWarning()"
      [class.is-invalid]="relativeStorage.shouldShowError()"
    >
      <!-- Item content -->
      <div class="item-content">
        <!-- Icon + label (either in link form or not, depending on whether a
             link is available) -->
        <a
          *ngIf="url"
          class="nav-link"
          [routerLink]="url"
          queryParamsHandling="merge"
        >
          <ng-container [ngTemplateOutlet]="linkTemplate"></ng-container>
        </a>
        <div *ngIf="!url" class="nav-link is-disabled">
          <ng-container [ngTemplateOutlet]="linkTemplate"></ng-container>
        </div>

        <!-- Pending validation -->
        <div
          class="status pending"
          *ngIf="relativeStorage.shouldShowPending()"
        ></div>
        <!-- Rejected validation -->
        <div
          class="status rejected"
          *ngIf="relativeStorage.shouldShowRejected()"
          (click)="relativeStorage.recomputeStateProperties()"
        >
          <lf-tooltip [help]="retryValidateText">
            <lf-icon icon="warning"></lf-icon>
          </lf-tooltip>
        </div>

        <!-- Actions -->
        <ng-container
          [ngTemplateOutlet]="actionsTemplate"
          [ngTemplateOutletContext]="{ alignRight: true }"
        ></ng-container>
      </div>

      <!-- Children -->
      <ng-container
        *ngIf="isActive"
        [ngTemplateOutlet]="childrenTemplate"
      ></ng-container>
    </div>
  </ng-container>
</ng-container>

<ng-template #linkTemplate>
  <!-- Icon for items with sub-items, either "v" or ">" or bars for lists -->
  <span *ngIf="isList || nonNullChildrenIds.length > 0" class="item-icon">
    <lf-icon
      [icon]="isList ? 'bars' : isActive ? 'angle-down' : 'angle-right'"
      [fixedWidth]="true"
    >
    </lf-icon>
  </span>

  <!-- Entry label -->
  <div class="item-label">{{ label }}</div>
</ng-template>

<!-- Template to show all children -->
<ng-template #childrenTemplate>
  <!-- Children -->
  <ng-container *ngFor="let id of nonNullChildrenIds">
    <nav class="nav flex-column">
      <lf-tree-entry
        [path]="id.toString()"
        [displayAsRoot]="false"
        [_componentLevel]="_componentLevel"
      ></lf-tree-entry>
    </nav>
  </ng-container>
</ng-template>

<!-- Template to show the item's action (if appropriate), either a button to add
     a new element to the list, or a menu to add an optional value; possibly,
     each action may be labelled and the menu aligned to the right -->
<ng-template
  #actionsTemplate
  let-addOptionalText="addOptionalValueButtonText"
  let-addToListText="addValueToListButtonText"
  let-alignRight="alignRight"
>
  <!-- Add optional value -->
  <div *ngIf="!isList && nullChildrenIds.length > 0" class="value-add">
    <lf-dropdown>
      <button
        lf-button
        [style]="'outline-secondary'"
        size="sm"
        [dropdownToggle]="true"
        [block]="true"
      >
        <lf-icon icon="plus-circle"></lf-icon>
        {{ addOptionalText }}
      </button>
      <!-- Align to the right when not -->
      <lf-dropdown-menu [alignRight]="alignRight">
        <button
          lf-dropdown-item
          *ngFor="let id of nullChildrenIds"
          (click)="initializeChild(id)"
        >
          {{ childLabel(id) }}
        </button>
      </lf-dropdown-menu>
    </lf-dropdown>
  </div>

  <!-- Add value to list -->
  <div *ngIf="isList" class="value-add">
    <button
      lf-button
      [style]="'outline-secondary'"
      [isDisabled]="maxSize != null && relativeStorage.size() >= maxSize"
      size="sm"
      (click)="addToList()"
    >
      <lf-icon icon="plus-circle"></lf-icon>
      {{ addToListText }}
    </button>
  </div>
</ng-template>
